export class HighImpactCommission {
	public contractId: string;
	public supplierId: string;
	public contractNum: string;
	public supplierName: string;
	public parentName: string;
	public agentName: string;
	public contactName: string;
	public commissionTypeName: string;
	public amount: number;
	public utilityAccountNumList: string;
	public dbaName: string;
	public commodity: string;
	public lastSupplierCommissionEmailLogCreatedAt: Date;

	constructor(highImpactCommission?: HighImpactCommission) {
		Object.assign(this, highImpactCommission);

		if (highImpactCommission?.lastSupplierCommissionEmailLogCreatedAt) {
			this.lastSupplierCommissionEmailLogCreatedAt = new Date(highImpactCommission.lastSupplierCommissionEmailLogCreatedAt);
		}
	}
}
